<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="flex align-center justify-between">
            <div class="search-container min flex align-center">
                <el-input v-model="keyword" placeholder="请输入姓名"></el-input>
                <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
            </div>
            <div class="flex align-center">
                <el-button class="btn max bg-orange radius" type="warning" @click="addMember()">
                    添加审核人员
                </el-button>
                <el-button class="btn min radius" type="primary" plain @click="delMembers">
                    删除{{lists.filter(f=>{ return f.isCheck}).length > 0 ? `(${lists.filter(f=>{ return f.isCheck}).length})` : ''}}
                </el-button>
            </div>
        </div>
        <div class="flex flex-direction">
            <div class="flex flex-wrap">
                <div v-for="(item,index) in lists" :key="index" class="member flex align-center justify-between radius margin-top">
                   <div class="flex align-center">
                       <el-checkbox v-model="item.isCheck"></el-checkbox>
                       <el-avatar class="margin-lr-sm" shape="square" :size="59">{{item.name | avatar}}</el-avatar>
                       <div>{{item.name}}</div>
                   </div>
                    <el-button class="text-orange underline" type="text" @click="addProject(item)">设置项目</el-button>
                </div>
            </div>
            <empty v-if="lists.length === 0" class="self-center" tip="暂无成员" ></empty>
        </div>
        <el-dialog
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`添加审核人员`"
            :visible.sync="addMemberDialog"
            center
            width="400px">
            <el-form class="publish-form"  ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
                <el-form-item label-width="0" prop="mid">
                    <el-select v-model="ruleForm.mid" placeholder="请选择" filterable>
                        <el-option
                            v-for="item in members.filter(f=>{ return !allMembers.some(s=> s.mid === f.mid)})"
                            :key="item.mid"
                            :label="item.name"
                            :value="item.mid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitForm('ruleForm')">添加</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog
            :before-close="cancel"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="`设置项目`"
            :visible.sync="addProjectDialog"
            center
            width="400px">
            <el-form class="publish-form"  ref="ruleProjectForm" :model="ruleProjectForm" :rules="project_rules" label-width="100px">
                <el-form-item label-width="0" prop="ids">
                    <el-select v-model="ruleProjectForm.ids" placeholder="请选择" filterable multiple>
                        <el-option
                            v-for="item in projects"
                            :key="item.id"
                            :label="item.p_name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <div class="text-red">注：设置不能审核的项目</div>
                </el-form-item>
                <el-form-item class="flex align-center justify-end" label-width="0">
                    <el-button @click="cancel">取消</el-button>
                    <el-button type="primary" @click="submitProjectForm('ruleProjectForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>

import {addAudit, delBatch, getNoVerifierUsers, getProjectIdNameList, getVerifierUsers, saveUserPower} from "@/api";
import {confirm, getAvatarName, TOAST, toast} from "@/utils/utils";

export default {
    name: "verifier-list",
    components: {},
    data() {
        return {
            keyword:'',
            lists: [],
            ruleForm: {
                mid: '',
            },
            rules: {
                mid: [
                    {required: true, message: '请选择成员', trigger: 'change'}
                ]
            },
            addMemberDialog: false,
            allMembers: [],
            members: [],
            ruleProjectForm: {
                ids: [],
            },
            project_rules: {
                // ids: [
                //     {required: true, message: '请选择项目', trigger: 'change'}
                // ]
            },
            addProjectDialog: false,
            projects: [],
            cur_mid:0
        }
    },
    created() {
        this.$emit('setIndex', [3,2], '审核人员管理', false)
        this.init()
        this.getProjectMember()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        search(){
           this.getProjectMember()
        },
        async init() {
            let _data = await getNoVerifierUsers()
            this.members = _data.data
            _data = await getProjectIdNameList()
            this.projects = _data.data
        },
        async getProjectMember() {
            let _data = await getVerifierUsers(this.keyword)
            _data.data.map(item=>{
                item.isCheck = false
            })
            this.lists = _data.data
            _data =  await getVerifierUsers('')
            this.allMembers = _data.data
        },
        addProject(data) {
            this.cur_mid = data.mid
            this.ruleProjectForm.ids = data.no_manage_project ? data.no_manage_project.split(',').map(item=>{ return Number(item)}) : []
            this.addProjectDialog = true
        },
        submitProjectForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitProject()
                }
            });
        },
        async submitProject() {
            let _data = await saveUserPower(this.cur_mid,this.ruleProjectForm.ids.join(','))
            if (_data.status === 200) {
                toast(`设置成功`, TOAST.success)
                this.getProjectMember()
                this.cancel()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        addMember() {
            this.ruleForm.mid = ''
            this.addMemberDialog = true
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                }
            });
        },
        async submitInfo() {
            let _data = await addAudit(this.ruleForm.mid)
            if (_data.status === 200) {
                toast(`添加成功`, TOAST.success)
                this.getProjectMember()
                this.cancel()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        delMembers() {
            if (!this.lists.some(s=> s.isCheck)) return  toast('请选择要移除的成员', TOAST.error)
            confirm(`移除的成员`, `你确定将<b>${this.lists.filter(f=>{ return f.isCheck}).map(item=>{ return item.name})}</b>从项目中移除吗？`, () => {
                this.delItem(this.lists.filter(f=>{ return f.isCheck}).map(item=>{ return item.mid}).join(','))
            }, '确认', true)
        },
        async delItem(ids) {
            let _data = await delBatch(ids)
            if (_data.status === 200) {
                toast(`删除成功`, TOAST.success)
                this.getProjectMember()
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        cancel() {
            this.addMemberDialog = false
            this.addProjectDialog = false
        },
    },
    filters:{
        avatar(name){
            return getAvatarName(name)
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .member{
        width: calc((100%  - (26px * 3)) / 4);
        height: 77px;
        border-radius: 10px;
        border: solid 1px #e6e6e6;
        padding: 0 15px;
        &:not(:nth-child(4n+1)) {
            margin-left: 26px;
        }
    }

}
</style>
